import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LaptopList from './pages/LaptopList';
import LaptopForm from './pages/LaptopForm';
import LaptopDetails from './pages/LaptopDetails';
import QRScanPage from './pages/QRScanPage';
import UserManagement from './pages/UserManagement';
import Reports from './pages/Reports';
import AccessManagement from './pages/AccessManagement';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/laptops"
              element={
                <ProtectedRoute>
                  <LaptopList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/laptops/new"
              element={
                <ProtectedRoute allowedRoles={['admin', 'super-admin']}>
                  <LaptopForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/laptops/:id/edit"
              element={
                <ProtectedRoute allowedRoles={['admin', 'super-admin']}>
                  <LaptopForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/laptops/:id"
              element={
                <ProtectedRoute>
                  <LaptopDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/scan"
              element={
                <ProtectedRoute>
                  <QRScanPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={['admin', 'super-admin']}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/access-management"
              element={
                <ProtectedRoute>
                  <AccessManagement />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
